import React, {Component} from 'react';
// import PortaleFilterWidgetLink from '../PortaleFilterWidgetLink';
import PortaleWidgetLink from '../PortaleWidgetLink';

export default class WidgetGestionePortale extends Component {
    createInitialFormValues(item) {
        return item;
    }

    render() {
        return (
            <div className="widget">
                <h2>Gestisci i portali</h2>
                <div className="row">
                    <div className="col-md-4">
                        <PortaleWidgetLink
                            icon="fas fa-window-restore"
                            to="/dashboardPortali/schedeHotel"
                        >
                            Schede Hotel
                        </PortaleWidgetLink>
                    </div>
                    {/* <div className="col-md-4">
                        <PortaleWidgetLink
                            icon="fas fa-tag"
                            to="/portale/:portaleId/consigliati"
                        >
                            Consigliati
                        </PortaleWidgetLink>
                    </div> */}
                    <div className="col-md-4">
                        <PortaleWidgetLink
                            to="/dashboardPortali/gallerie"
                            icon="fas fa-images"
                        >
                            Gallery e foto
                        </PortaleWidgetLink>
                    </div>
                    <div className="col-md-4">
                        <PortaleWidgetLink
                            icon="fas fa-file"
                            to="/dashboardPortali/pagine"
                        >
                            Pagine Destinazione
                        </PortaleWidgetLink>
                    </div>
                    <div className="col-md-4">
                        <PortaleWidgetLink
                            icon="fas fa-file"
                            to="/dashboardPortali/portaliPagineOfferte"
                        >
                            Pagine Offerte
                        </PortaleWidgetLink>
                    </div>
                    <div className="col-md-4">
                       <PortaleWidgetLink
                            icon="fas fa-list-alt"
                            to="/portaliIndicatoriHotels"
                        >
                            Indicatori
                        </PortaleWidgetLink>
                    </div>
                    {/*<div className="col-md-4">*/}
                    {/*    <PortaleWidgetLink*/}
                    {/*        icon="fas fa-plane-arrival"*/}
                    {/*        to="/dashboardPortali/landingPage"*/}
                    {/*    >*/}
                    {/*        Landing Page*/}
                    {/*    </PortaleWidgetLink>*/}
                    {/*</div>*/}
                    {/*<div className="col-md-4">*/}
                    {/*    <PortaleWidgetLink*/}
                    {/*        icon="fas fa-list-alt"*/}
                    {/*        to="/dashboardPortali/portaliIndicatoriHotels"*/}
                    {/*    >*/}
                    {/*        Indicatori unificati*/}
                    {/*    </PortaleWidgetLink>*/}
                    {/*</div>
                    {/*<div className="col-md-4">*/}
                    {/*    <PortaleWidgetLink*/}
                    {/*        icon="fas fa-list"*/}
                    {/*        to="/dashboardPortali/indicatori"*/}
                    {/*    >*/}
                    {/*        Indicatori*/}
                    {/*    </PortaleWidgetLink>*/}
                    {/*</div>*/}
                    {/*<div className="col-md-4">*/}
                    {/*    <PortaleWidgetLink*/}
                    {/*        icon="fas fa-sync-alt"*/}
                    {/*        to="/dashboardPortali/redirect"*/}
                    {/*    >*/}
                    {/*        Redirect*/}
                    {/*    </PortaleWidgetLink>*/}
                    {/*</div>*/}
                    {/*<div className="col-md-4">*/}
                    {/*    <PortaleWidgetLink*/}
                    {/*        icon="fas fa-file-alt"*/}
                    {/*        to="/dashboardPortali/articoli"*/}
                    {/*    >*/}
                    {/*        Articoli*/}
                    {/*    </PortaleWidgetLink>*/}
                    {/*</div>*/}
                    <div className="col-md-4">
                        <PortaleWidgetLink
                            icon="fas fa-bed"
                            to="/dashboardPortali/portaliCamere"
                        >
                            Camere
                        </PortaleWidgetLink>
                    </div>
                    <div className="col-md-4">
                        <PortaleWidgetLink
                            icon="fas fa-poll-h"
                            to="/dashboardPortali/portaliServiziTop"
                        >
                            Servizi Top
                        </PortaleWidgetLink>
                    </div>
                    <div className="col-md-4">
                        <PortaleWidgetLink
                            icon="fas fa-poll-h"
                            to="/portaliLanding"
                        >
                            Landing
                        </PortaleWidgetLink>
                    </div>
                    <div className="col-md-4">
                        <PortaleWidgetLink
                            icon="fas fa-poll-h"
                            to="/impostazioniCpa"
                        >
                            Impostazioni CPA
                        </PortaleWidgetLink>
                    </div>
                </div>
            </div>
        );
    }
}
